/**
 * Browser API requests intentionally receive a fresh `cb` timestamp from
 * AuthInterceptor. A prerendered request and its browser equivalent therefore
 * cannot share an Angular HTTP transfer-cache key. Excluding only those
 * requests avoids serializing responses the browser can never reuse while
 * preserving transfer caching for stable HttpClient GET requests.
 */
export function shouldIncludeInHttpTransferCache(request: {
  readonly url: string;
}): boolean {
  return !/[?&]cb=\d+(?:&|$)/.test(request.url);
}
